const panelIconTabsPropsMap = {
  valid: { variant: 'valid' },
  'partial-success': { variant: 'partial-success' },
  pending: { variant: 'light-medium' },
  invalid: { variant: 'error', size: 12 },
  redeploy: { variant: 'warning' }
};

export default panelIconTabsPropsMap;
